import { createSelector } from 'reselect'
import userFullNameSelector from 'redux/selectors/user/user_full_name_selector'
import viewTypes from 'helpers/enums/viewTypes'

const getUserDataSelector = state => state.user.data
const getUIDataSelector = state => state.ui

const getIntercomData = createSelector(
	[getUserDataSelector, userFullNameSelector, getUIDataSelector],
	(userData, userFullName, uiData) => {
		const views = [
			`${viewTypes.SCHOOL_LIBRARY}-library`,
			`${viewTypes.DISTRICT_LIBRARY}-library`,
		]
		const shouldShowIntercom = userData.intercomIO
			&& !(views.includes(uiData.currentView) && uiData.isInIframe)
			|| false

		return {
			shouldShowIntercom,
			intercomData: {
				user_id: userData.userId || '',
				email: userData.email || '',
				name: userFullName,
				created_at: userData.created || '',
			},
		}
	}
)

export default getIntercomData
